// extracted by mini-css-extract-plugin
export default {"cls1":"News-cls1_THr","cls2":"News-cls2_d3H News-cls1_THr"};